import type { MenuConfig } from '~typings/menu'

import permisosPresupuesto, { RESOURCE_PRESUPUESTO } from '@/auth/permissions/modules/presupuesto'
import * as routes from '@routes/presupuesto/nombres/transacciones'

const { transacciones } = permisosPresupuesto
export default [
    {
        title: 'presupuesto.subopciones.bandeja_presupuesto',
        resource: RESOURCE_PRESUPUESTO,
        action: transacciones.bandejaPresupuesto,
        route: routes.ROUTE_BANDEJA_PRESUPUESTO,
    },
    {
        title: 'presupuesto.subopciones.aprobar_presupuesto',
        resource: RESOURCE_PRESUPUESTO,
        action: transacciones.aprobacionPresupuesto,
        route: routes.ROUTE_APROBAR_PRESUPUESTO,
    },
    {
        title: 'presupuesto.subopciones.alcance_presupuesto',
        resource: RESOURCE_PRESUPUESTO,
        action: transacciones.alcancePresupuesto,
        route: routes.ROUTE_ALCANCE_PRESUPUESTO,
    },
    {
        title: 'presupuesto.subopciones.bandeja_solicitudes_alcance',
        resource: RESOURCE_PRESUPUESTO,
        action: transacciones.bandejaSolicitudAlcance,
        route: routes.ROUTE_BANDEJA_SOLICITUD_ALCANCE,
    },
    {
        title: 'presupuesto.subopciones.aprobacion_alcance_presupuesto',
        resource: RESOURCE_PRESUPUESTO,
        action: transacciones.aprobacionAlcancePresupuesto,
        route: routes.ROUTE_APROBACION_ALCANCE_PRESUPUESTO,
    },
] as MenuConfig[]
